/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  exportIcon,
  mailCheckIcon,
  rightUserIcon,
  twoUserIcon,
  whatsapp,
} from "../assets";
import { Checkbox, Input, Select, Table } from "antd";
import "../styles/CandidateListPage.css";
import { get, post } from "../lib/Api";
import { ToastContainer } from "react-toastify";
import Toast from "../components/Toast/Toast";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import CandidateDetails from "./CandidateDetails";
const baseUrl = process.env.REACT_APP_BACKEND_URL;

dayjs.extend(customParseFormat);

const CandidateListPage = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchValue);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [selectedCandidateType, setSelectedCandidateType] = useState("all");
  const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
  useState(false);

  const [candidateCardCount, setCandidateCardCount] = useState({
    totalCandidates: "",
    selfUpdate: "",
    uploadedByRecruiter: "",
    selfRegistration: "",
    invitedCandidates: "",
  });

  const [candidateType, setCandidateType] = useState([]);
  const [visibleDetails, setVisibleDetails] = useState(false);
  const [currentCandidate, setCurrentCandidate] = useState(null);

  const handleVisibleDetails = (candidate) => {
    setCurrentCandidate(candidate);
    setVisibleDetails(true);
  };

  const handleCloseDetails = () => {
    setVisibleDetails(false);
    setCurrentCandidate(null);
  };

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
      pageSizeOptions: ["10", "50", "100", "200", "500"],
      showSizeChanger: true,
    },
  });

  const handleBlacklistSuccess = (isSuccess) => {
    if (isSuccess) {
      fetchData();
    }
  };

  const columns = [
    {
      title: (
        <Checkbox
          onChange={(e) => handleSelectAll(e.target.checked)}
          checked={
            selectedCandidateIds?.length === data?.length && data?.length > 0
          }
          // indeterminate={
          //   selectedCandidateIds.length > 0 &&
          //   selectedCandidateIds.length < data.length
          // }
        />
      ),
      dataIndex: "id",
      key: "select",
      width: "5%",
      render: (id) => (
        <Checkbox
          onChange={(e) => handleSelect(id, e.target.checked)}
          checked={selectedCandidateIds.includes(id)}
        />
      ),
    },
    {
      title: "Name & Email",
      sorter: true,
      key: "name",
      render: (result) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* <div><img src={profileUserIcon} alt="User Icon"/></div> */}
          <div
            style={{ paddingLeft: "10px", cursor: "pointer" }}
            onClick={() => handleVisibleDetails(result)}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#00adf0";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "black";
            }}
          >
            <div
              style={{ fontWeight: 500, fontSize: "14px", lineHeight: "17px" }}
            >{`${result.name}`}</div>
            <div
              style={{ fontWeight: 400, fontSize: "14px", lineHeight: "17px" }}
            >
              {result.email}
            </div>
          </div>
        </div>
      ),
      width: "25%",
    },
    {
      title: "Experience",
      dataIndex: "experience",
      width: "13%",
      align: "center",
      key: "experience",
      render: (result) => <>{result} Year</>,
    },
    {
      title: "Annual Salary",
      dataIndex: "annual_salary",
      width: "15%",
      align: "center",
      key: "annual_salary",
      render: (result) => <>₹ {result}</>,
    },
    {
      title: "Location",
      // dataIndex: "zone",
      width: "10%",
      align: "center",
      key: "location",
      render: (result) => (
        <>
          {" "}
          {result?.city}, {result?.state}
        </>
      ),
    },
    {
      title: "Type",
      dataIndex: "candidate_type",
      width: "10%",
      align: "center",
      key: "candidate_type",
    },
    {
      title: "Last Login",
      dataIndex: "lastActiveDate",
      width: "15%",
      align: "center",
      key: "lastActiveDate",
      sorter: true,
      render: (result) => (
        <>{result ? dayjs(result).format("DD-MM-YYYY") : "N/A"}</>
      ),
    },
  ];

  const getRandomuserParams = (params) => ({
    page_no: params.pagination?.current,
    page_size: params.pagination?.pageSize,
    query: debouncedValue,
    candidate_type: selectedCandidateType,
    filter: selectedStatus,
    sort_order: params.sortOrder,
  });

  const fetchData = async () => {
    setLoading(true);
    const res = await get(
      `candidate/master-list`,
      getRandomuserParams(tableParams),
      {},
      true
    );
    if (res?.status === true) {
      setData(res.candidate_profile_list.results);
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: res.count,
        },
      });
      setLoading(false);
    } else {
      Toast({ message: res?.message, type: "error" });
      setLoading(false);
    }
  };

  const fetchCandidateCardCount = async () => {
    setLoading(true);
    const res = await get(`candidate/count`, null, {}, true);
    if (res?.status === true) {
      setCandidateCardCount({
        totalCandidates: res.data.total,
        selfUpdate: res.data.self_update,
        uploadedByRecruiter: res.data.uploaded_by_recruiter,
        selfRegistration: res.data.self_registration,
        invitedCandidates: res.data.invited,
      });
      setLoading(false);
    } else {
      Toast({ message: res?.message, type: "error" });
      setLoading(false);
    }
  };

  const fetchCandidateType = async () => {
    setLoading(true);
    const res = await get(`candidate/type`, null, {}, true);
    if (res?.status === true) {
      setCandidateType(res.data);
      setLoading(false);
    } else {
      Toast({ message: res?.message, type: "error" });
      setLoading(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    fetchData();
    fetchCandidateCardCount();
  }, [
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    JSON.stringify(tableParams.filters),
    debouncedValue,
    selectedStatus,
    selectedCandidateType,
  ]);

  useEffect(() => {
    fetchCandidateType();
  }, []);

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const handleCandidateTypeChange = (value) => {
    setSelectedCandidateType(value);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams((prev) => ({
      ...prev,
      pagination: {
        ...pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
      filters,
      sortOrder: Array.isArray(sorter)
        ? undefined
        : `${sorter.columnKey}: ${sorter.order}`,
    }));

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const handleSelect = (candidateId, isChecked) => {
    setSelectedCandidateIds((prev) =>
      isChecked
        ? [...prev, candidateId]
        : prev.filter((id) => id !== candidateId)
    );
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      const allIds = data.map((candidate) => candidate.id);
      setSelectedCandidateIds(allIds);
    } else {
      setSelectedCandidateIds([]);
    }
  };

  const handleInvite = async () => {
    setLoading(true);
    if (!selectedCandidateIds.length) {
      Toast({
        message: "Please select at least single candidate to invite",
        type: "error",
      });
      setLoading(false);
      return;
    }
    try {
      let res;
      const data = {
        candidates_list: selectedCandidateIds,
      };
      res = await post(`candidate/invite-message`, data, {}, true);
      if (res?.status === true) {
        setSelectedCandidateIds([]);
        fetchData();
        Toast({ message: res.message, type: "success" });
      } else {
        Toast({ message: res?.message, type: "error" });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error", error);
      Toast({
        message: "Network Error",
        type: "error",
      });
    }
  };

  const handleExport = async () => {
    setLoading(true);
    if (!selectedCandidateIds.length) {
      Toast({
        message: "Please select at least single candidate to Export",
        type: "error",
      });
      setLoading(false);
      return;
    }
    try {
      let res;
      const data = {
        candidates_list: selectedCandidateIds,
      };
      res = await post(`candidate/master-export`, data, {}, true);
      if (res?.status === true) {
        const element = document.createElement("a");
        element.href = baseUrl + res.file_path;
        element.download = "";
        element.click();
        setSelectedCandidateIds([]);
        Toast({ message: res.message, type: "success" });
      } else {
        Toast({ message: res?.message, type: "error" });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error", error);
      Toast({
        message: "Network Error",
        type: "error",
      });
    }
  };

  return (
    <div className="rcontainer">
      <div className="header">
        <div>
          <div className="header-title">Candidates</div>
          <div className="header-subtitle">
            Manage and view the list of candidates, including their details,
            statuses, and actions.
          </div>
        </div>
        <div className="button-group">
          <div>
            <button
              className="secondary-button"
              title="Export Recruiter's Data"
              onClick={handleExport}
            >
              <img src={exportIcon} alt="exportIcon" />
              Export
            </button>
          </div>
          <div>
            <button
              className="secondary-button"
              title="Import bulk Recruiters"
              onClick={handleInvite}
              disabled={loading}
            >
              <img src={whatsapp} alt="whatsapp Icon" />
              Invite
            </button>
          </div>
        </div>
      </div>

      <div className="candidate-list-stats-cards">
        <div className="candidate-list-stats-card">
          <div>
            <img src={twoUserIcon} alt="twoUserIcon" />
          </div>
          <div className="candidate-list-stats-right-content">
            <div className="title">Total Candidates</div>
            <div className="value">{candidateCardCount.totalCandidates}</div>
          </div>
        </div>
        <div className="candidate-list-stats-card">
          <div>
            <img src={rightUserIcon} alt="rightUserIcon" />
          </div>
          <div className="candidate-list-stats-right-content">
            <div className="title">Self Update</div>
            <div className="value">{candidateCardCount.selfUpdate}</div>
          </div>
        </div>
        <div className="candidate-list-stats-card">
          <div>
            <img src={rightUserIcon} alt="rightUserIcon" />
          </div>
          <div className="candidate-list-stats-right-content">
            <div className="title">Uploaded by Recruiter</div>
            <div className="value">
              {candidateCardCount.uploadedByRecruiter}
            </div>
          </div>
        </div>
        <div className="candidate-list-stats-card">
          <div>
            <img src={rightUserIcon} alt="rightUserIcon" />
          </div>
          <div className="candidate-list-stats-right-content">
            <div className="title">Self registration</div>
            <div className="value">{candidateCardCount.selfRegistration}</div>
          </div>
        </div>
        <div className="candidate-list-stats-card">
          <div>
            <img src={mailCheckIcon} alt="mailCheckIcon" />
          </div>
          <div className="candidate-list-stats-right-content">
            <div className="title">Invited Candidate</div>
            <div className="value">{candidateCardCount.invitedCandidates}</div>
          </div>
        </div>
      </div>

      <div className="filter-section">
        <div className="filter-bar">
          <div className="filter-group">
            <div>
              <Input
                placeholder="Search by Name, Email, PhoneNo or Recruiter Code"
                className="search-input"
                prefix={
                  <SearchOutlined
                    style={{
                      color: "rgba(0,0,0,.25)",
                      fontSize: "20px",
                    }}
                  />
                }
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <div>
              <Select
                defaultValue="all"
                className="filter-select"
                onChange={handleStatusChange}
                options={[
                  { value: "all", label: "All" },
                  { value: "invited", label: "Invited" },
                  { value: "not_invited", label: "Not-Invited" },
                  { value: "self_update", label: "Self-Update" },
                  {
                    value: "uploaded_by_recruiter",
                    label: "Uploaded by Recruiter",
                  },
                  { value: "self_registration", label: "Self Registration" },
                  { value: "deactivate_account", label: "Deactivate account" },
                ]}
              />
            </div>
            <div>
              <Select
                defaultValue="all"
                className="filter-select"
                onChange={handleCandidateTypeChange}
                options={candidateType}
              />
            </div>
          </div>
          {/* <div>
            <button className="filter-button">
              <img src={filterIcon} alt="Filter Icon" /> <span>Filter</span>
            </button>
          </div> */}
        </div>
        <div className="table-container">
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={data}
            pagination={tableParams.pagination}
            loading={loading}
            onChange={handleTableChange}
          />
        </div>
      </div>

      <CandidateDetails
        visibleDetails={visibleDetails}
        candidate={currentCandidate}
        onClose={handleCloseDetails}
        onBlacklistSuccess={handleBlacklistSuccess}
      />

      <ToastContainer />
    </div>
  );
};

export default CandidateListPage;
